<script lang="ts">
  import ButtonLink from '@components/inputs/button-link/ButtonLink.svelte'
  import ArrowIcon from '@images/chevron.svg'

  export let onClick: (...args: unknown[]) => unknown
</script>

<ButtonLink icon={ArrowIcon} {onClick} text="Back" />
